import { render, staticRenderFns } from "./BmProductoPrecio.vue?vue&type=template&id=5b031422&"
import script from "./BmProductoPrecio.vue?vue&type=script&lang=js&"
export * from "./BmProductoPrecio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports